import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import { _, _all } from './modules/dom';

const sliderClass = '.we-block-slider';
const wrapperClass = `${sliderClass}__slides`;

_all(sliderClass).forEach(slider => {
    const slides = _(wrapperClass, slider);

    if (slides) {
        const options = {
            modules: [ Navigation, Pagination, Autoplay, EffectFade ],
        };

        if (slider.dataset.sliderLoop == 'true') {
            options.loop = true;
        }

        if (slider.dataset.sliderAutoplayDelay) {
            options.autoplay = {
                delay: Number(slider.dataset.sliderAutoplayDelay),
            };
        }

        const effect = slider.dataset.sliderEffect;
        if (effect == 'fade') {
            options.effect = 'fade';
            options.fadeEffect = { crossFade: true };
        }

        // console.log(options);
        new Swiper(slider, options);
    }
});
